<div
	class="vehicles-swiper swiper"
	#swiperContainer
>
	<div class="swiper-wrapper">
		@for (vehicle of vehicles; track vehicle.idVehicle) {
			<div class="swiper-slide vehicle-card me-4">
				@if (utils.isEmpty(vehicle.appraisalCode)) {
					<img
						loading="lazy"
						[src]="utils.isNullOrUndefined(vehicle.idPrincipalPhoto) ? wcmService.noPhotoUrl : utils.getImageUrl(vehicle.idPrincipalPhoto)"
					/>
				} @else {
					<img
						loading="lazy"
						src="{{ vehicle.imageUrl || wcmService.noPhotoUrl }}"
						alt="{{ vehicle.brand + ' ' + vehicle.model }}"
					/>
				}
				<div
					class="vehicle-title text-blue text-truncate"
					[title]="vehicle.brand + ' ' + vehicle.model"
				>
					{{ vehicle.brand }} {{ vehicle.model }}
				</div>
			</div>
		}
	</div>

	<button
		class="swiper-button-prev"
		#prevBtn
		type="button"
		(click)="onPrev()"
		aria-label="Previous slide"
	></button>
	<button
		class="swiper-button-next"
		#nextBtn
		type="button"
		(click)="onNext()"
		aria-label="Next slide"
	></button>
</div>
